<template>
  <div class="d-flex flex-column p-1" style="width: 70rem; height: auto; max-width: 100%;">
    <el-card shadow="always">
      <div class="d-flex flex-column">
        <div class="d-flex flex-column flex-md-row align-items-md-center">
          <div>
            <img src="/icon/parsec.svg" style="height: 2rem" />
          </div>
          <div class="mt-3 ml-md-5" style="font-weight: 500">
            Parsec | Connect to Work or Games from Anywhere
          </div>
        </div>
        <div
          class="mt-4 pt-4"
          style="border-top: 1px solid #e0e0e0; font-size: 0.85rem"
        >
          Remote desktop you’ll actually love, in crystal clear, interactive HD.
          Connect to work, games, or projects wherever you are, whenever you
          want.
        </div>
        <div>
          <el-link
            class="mt-3"
            style="color: #42a5f5"
            href="https://docs.gpuhub.net/technical-documentation/parsec/set-up-parsec-to-use-irender-servers/"
            target="_blank"
            :underline="false"
            >Tutorial for installing Parsec on iRender's system</el-link
          >
        </div>
        <div class="d-flex justify-content-end mt-10">
          <el-button @click="goToExtraService" plain round >
            <span class="d-none d-md-inline">Request software installation support</span>
            <span class="d-inline d-md-none">Request installation support</span>
          </el-button >
          <el-button
            @click="openUrl('https://parsec.app/')"
            type="primary"
            round
            >Download</el-button
          >
        </div>
      </div>
    </el-card>
    <el-card class="mt-5" shadow="always">
      <div class="d-flex flex-column">
        <div class="d-flex flex-column flex-md-row align-items-md-center">
          <div>
            <img src="/icon/teamviewer.svg" style="height: 2rem" />
          </div>
          <div class="mt-3 ml-md-5" style="font-weight: 500">
            TeamViewer | The Remote Desktop Software
          </div>
        </div>
        <div
          class="mt-4 pt-4"
          style="border-top: 1px solid #e0e0e0; font-size: 0.85rem"
        >
          The TeamViewer suite of remote connectivity, augmented reality, IT
          management, and customer-first engagement solutions empowers you to
          connect to any device to support anyone, any process, or anything —
          from anywhere, anytime.
        </div>
        <div class="d-flex justify-content-end mt-10">
          <el-button
            @click="openUrl('https://www.teamviewer.com/')"
            type="primary"
            round
            >Download</el-button
          >
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
//Lib
import { mapState } from "vuex";

// Extend
import base from "@/scripts/base";

export default {
  extends: base,

  data() {
    return {
      qualityList: {
        normal: 1,
        optimizePerformance: 2,
      },

      request: {
        quality: 1,
      },
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  props: {
    targetImage: {
      type: Object,
      default: null,
    },
  },

  methods: {
    goToExtraService() {
      this.$emit("processingEvent", {
        event: "closeThisPopup",
      });
      this.pushUrl(this.routeUrl.EXTRA_SERVICE_CONTAINER);
    },
  },
};
</script>